import React from 'react';
import { PRICING } from '../pricing';
import PeopleIcon from '@mui/icons-material/People';

export const mentorship = {
    title: "1:1 AI Tutoring",
    subtitle: "Expert Guidance",
    badge: "FREEMIUM",
    icon: <PeopleIcon sx={{ fontSize: 40, color: '#ec4899' }} />,
    description: "Personalized guidance from industry experts in AI/ML & Software Engineering.",
    marketing: {
      image: '/flowstate/mentor_program_laptop.png',
      labels: ['Dedicated Mentor', 'Custom Roadmap'],
      cta: 'View Program'
    },
    features: [
      "Personalized Roadmap",
      "Mock Interviews",
      "Resume Review"
    ],
    price: PRICING.mentorship.price,
    mrp: PRICING.mentorship.mrp
  };
